module.exports = __webpack_public_path__ + "media/besofen_2.a5f8c354.mp4";